.dealsPage {
  /* 24px inset to align with the header and all other pages inside the 1240px container */
  padding: 0 24px;
}

.welcomeUser {
  padding: 2rem 0 1.2rem 0;
}

.deals {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'deal deal';
  padding: 0 0 2rem 0;
  gap: 1rem;
}

.deal {
  grid-area: deal;
}

@media only screen and (max-width: 550px) {
  .dealsPage {
    padding: 0 14px;
  }
  .deals {
    grid-template-columns: 1fr;
    grid-template-areas: 'deal';
  }
}

